import {
  Box,
  Card,
  Checkbox,
  Dialog,
  FormControl,
  InputLabel,
  MenuItem,
  Button as MUIButton,
  Select,
  Tooltip,
  Typography,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import { ReactElement, useState, useMemo } from 'react';
import {
  BulkDeleteButton,
  CreateButton,
  Datagrid,
  EditButton,
  Filter,
  FunctionField,
  useListContext,
  List,
  TextField,
  NumberField,
  TopToolbar,
  useListController,
  useTranslate,
  DeleteButton,
  SelectField,
  TextInput,
  SelectInput,
} from 'react-admin';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { Resources } from '../../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionButton } from 'src/routes/components/permission-button';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import AddressField from 'src/pages/admin/components/AddressField';
// import CreateMetadata from './Create';
// import EditMetadata from './Edit';
import FilterGroup from 'src/pages/admin/components/FilterGroup';
import XTextInput from 'src/pages/admin/components/XTextInput';
import { chains } from 'src/assets/data';

const ListFilter = (props: any) => {
  const { filterValues } = useListContext();
  // console.log('filterValues===', filterValues);
  // console.log('props===', props);

  return (
    <Filter {...(props || {})}>
      {/* <FilterGroup alwaysOn spacing={0} p={0}>
        <FilterGroup>
          <TextInput source="address" label="module.swapUserDetail.address" />
          <SelectInput
              source="chainId"
              helperText={<span style={{ color: 'red' }}></span>}
              choices={[
                  { id: 501424, name: 'SOLANA' },
                  { id: 1, name: 'ETH' }
              ]}
          />
        </FilterGroup>
      </FilterGroup> */}
    </Filter>
  );
};

const View = () => {
  const [popup, setPopup] = useState<ReactElement>();
  const translate = useTranslate();

  const permanentFilter = useMemo(() => ({ userAddress: '0xadmin' }), []);

  return (
    <DashboardContent>
      <PermissionGuard resource="swap-user-detail" action="read" fallback={<ErrorPage403 />}>
        <CustomBreadcrumbs
          heading={translate('resource.swapUserDetail')}
          links={[
            { name: translate('resource.swapUser'), href: '#' },
            { name: translate('resource.swapUserDetail'), href: `/${Resources.swapUserDetail}` },
            { name: translate('resource.list') },
          ]}
          // action={
          //   <PermissionGuard resource="swap-user-detail" action="create" fallback={<></>}>
          //     <CreateButton variant="contained" size='medium' onClick={(e)=> {
          //       e.preventDefault()
          //       setPopup(<CreateMetadata onClose={() => setPopup(undefined)} />)
          //     }} />
          //   </PermissionGuard>
          // }
        />

        <Card sx={{ mt: 3, pb: 2 }}>
          <List
            actions={false}
            empty={false}
            filters={<ListFilter />}
            perPage={10}
            exporter={false}
            disableSyncWithLocation
            filter={permanentFilter}
          >
            <Box sx={{ overflow: 'auto' }}>
              <Datagrid
                rowClick={false}
                bulkActionButtons={
                  <PermissionButton resource="swap-user-detail" action="delete">
                    <BulkDeleteButton />
                  </PermissionButton>
                }
                sx={{
                  '.RaBulkActionsToolbar-toolbar': {
                    position: 'relative !important',
                    transform: 'none !important',
                  },
                  '& .left-col': { textAlign: 'left' },
                }}
              >
                <TextField source="route" label="module.swapUserDetail.route" sortable={false} />
                <NumberField
                  source="amountUsd"
                  label="module.swapUserDetail.amountUsd"
                  cellClassName="left-col"
                  headerClassName="left-col"
                  sortable={false}
                />

                <FunctionField
                  label="module.swapUserDetail.timestamp"
                  source="timestamp"
                  sortable={false}
                  render={(r: any) =>
                    r?.timestamp ? dayjs(r.timestamp * 1000).format('YYYY-MM-ss HH:mm:ss') : '-'
                  }
                />
              </Datagrid>
            </Box>
          </List>
        </Card>
        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="md" fullWidth>
          {popup}
        </Dialog>
      </PermissionGuard>
    </DashboardContent>
  );
};

export default View;
